function escapeRegExp(value: string): string {
  return value.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")
}

function labelAlreadyContainsUnit(label: string, unit: string): boolean {
  return new RegExp(`(?:^|\\s)${escapeRegExp(unit)}\\s*$`, "i").test(label)
}

export function formatFacetElementLabel(elementName: string, unit?: string): string {
  const label = elementName.trim()
  const unitLabel = unit?.trim()

  if (!unitLabel || labelAlreadyContainsUnit(label, unitLabel)) {
    return label
  }

  return `${label} ${unitLabel}`
}
